import React from 'react';
import ReactOnRails from 'react-on-rails';
import { Provider } from 'react-redux';

import WarrantySubmitClaims from './WarrantyClaimsForm';

export default props => {
  const warrantyClaimStore = ReactOnRails.getStore('warrantyClaimStore');

  return (
    <Provider store={warrantyClaimStore}>
      <WarrantySubmitClaims {...props} />
    </Provider>
  );
};
